import { CustomInverterType, ErrorFeature, InverterData, InverterDataComposer, RegisterTable } from '../lib/inverter.model';
import { decodeHistoryEventG3 } from '../lib/modbus.utils';
import { create_HistoryEventList, V3HistoryEventsConfig } from './inverter.config';

export const V3HistoryEvents: Partial<RegisterTable> = {};

const history_events_section_start = V3HistoryEventsConfig.HistoryEvents.address;
const history_events_section_index_start = V3HistoryEventsConfig.HistoryEvents.indexStart;
for (let i = 1; i <= V3HistoryEventsConfig.HistoryEvents.length; i++) {
  const { id, yM, dH, ms } = create_HistoryEventList(
    history_events_section_index_start + (i - 1),
    history_events_section_start + (i - 1) * 4,
  );
  V3HistoryEvents[`HistoryEvent_ID${history_events_section_index_start + (i - 1)}`] = id;
  V3HistoryEvents[`HistoryEvent_yM${history_events_section_index_start + (i - 1)}`] = yM;
  V3HistoryEvents[`HistoryEvent_dH${history_events_section_index_start + (i - 1)}`] = dH;
  V3HistoryEvents[`HistoryEvent_ms${history_events_section_index_start + (i - 1)}`] = ms;
}

export const ComposeV3HistoryEvents: Partial<InverterDataComposer> = { };

for (let i = 1; i <= V3HistoryEventsConfig.HistoryEvents.length; i++) {
  ComposeV3HistoryEvents[`HistoryEvent_Compose_${history_events_section_index_start + (i - 1)}`] = (data: Partial<InverterData>) => {
    const id = data[`HistoryEvent_ID${history_events_section_index_start + (i - 1)}`] as number;
    const yM = data[`HistoryEvent_yM${history_events_section_index_start + (i - 1)}`] as number;
    const dH = data[`HistoryEvent_dH${history_events_section_index_start + (i - 1)}`] as number;
    const ms = data[`HistoryEvent_ms${history_events_section_index_start + (i - 1)}`] as number;
    const year = (yM >> 8) + 2000;
    const month = (yM & 0xff) - 1;
    const day = dH >> 8;
    const hour = dH & 0xff;
    const minute = ms >> 8;
    const second = ms & 0xff;

    let descriptions: ErrorFeature[] = [];
    try {
      const feature = decodeHistoryEventG3(Math.floor(id / 16) + 1, (id % 16) - 1).feature;
      descriptions = feature ? [feature] : [];
    } catch (error) {
      descriptions = [];
    }

    data[`HistoryEvent_Compose_${history_events_section_index_start + (i - 1)}`] = {
      type: CustomInverterType.EventList,
      value: {
        index: history_events_section_index_start + (i - 1),
        id,
        descriptions,
        date: new Date(year, month, day, hour, minute, second),
      },
    };

    return data;
  };
}
